export default function Inner({ children }) {
    return <div className="z-10 w-full h-full max-w-[1320px] m-auto p-5">{children}</div>
}